import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function TermsAndConditions() {
  return (
    <div>
      <Accordion className="space-y-4" collapsible type="single">
        <AccordionItem value="item-1">
          <AccordionTrigger>1. Definition and Interpretation</AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li className="leading-loose">
                The General Terms shall apply and govern each and/or all of the
                Services in addition to any Specific Terms, and in the event,
                there is a conflict of inconsistency between the Terms, it shall
                be resolved in a manner most favourable to the Service Provider.
              </li>
              <li className="leading-loose">
                Broadband Services refer to mobile wireless broadband (FREEDOM),
                fixed broadband (FTTH internet) services (INFINITY) and WIFI
                services.
              </li>
              <li className="leading-loose">
                This Specific Terms and Conditions for Broadband Services shall
                apply and govern all products and Services in relation to
                FREEDOM, INFINITY and wireless Plans depicted on the Platform
                under the umbrella of the General Terms.
              </li>
              <li className="leading-loose">
                In this Specific Terms and Conditions for Broadband Services,
                words and expressions shall have the same meaning as outlined in
                Clause 1.1 of the ‘General Terms’ and Conditions of Services.
              </li>
              <li className="leading-loose">
                Unless otherwise stated with reference to any other Terms, any
                reference made in this Specific Terms to any Clauses shall be
                interpreted as to Clauses within these terms.
              </li>
              <li className="leading-loose">
                Unless otherwise stated to be for International or Roaming use,
                the provision of Services for data in these Specific Terms shall
                be interpreted for local use only.
              </li>
            </ol>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-2">
          <AccordionTrigger>2. Registration Information</AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li className="leading-loose">
                Registration for Broadband Plans must be submitted in compliance
                with all applicable Registration Forms in addition to the
                supplementary information required by the Service Provider
                according to the classification of the Broadband Subscriber.
              </li>
              <li className="leading-loose">
                Registration for Broadband Plans can be done either online via
                the Platform, at any of the Service Provider’s branch or via an
                authorised sales agent of the Service Provider.
              </li>
            </ol>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-3">
          <AccordionTrigger>
            3. Mobile Wireless Broadband Plans
          </AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li className="leading-loose">
                The different types of mobile wireless broadband Plans
                Subscribers may engage in pursuant to Clause 2 are as listed on
                the Platform.
              </li>
            </ol>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-4">
          <AccordionTrigger>4. Fixed Broadband Plans</AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li className="leading-loose">
                The different types of fixed broadband Plans Subscribers may
                engage in pursuant to Clause 2 are as listed on the Platform.
              </li>
              <li className="leading-loose">
                The availability and provision of the fixed broadband Service is
                subject to the Subscriber’s installation address being
                fibre-ready and subject to the network availability.
              </li>
            </ol>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-5">
          <AccordionTrigger>5. Add-On Bundles</AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li className="leading-loose">
                The available Data Add-On Bundles which can be purchased to
                supplement the mobile wireless broadband and/or fixed broadband
                Services are as listed on the Platform.
              </li>
            </ol>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-6">
          <AccordionTrigger>
            6. Installation of Fixed Broadband Service
          </AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li className="leading-loose">
                The Subscriber will receive a call from the Service Provider
                confirming the installation appointment date and time.
              </li>
              <li className="leading-loose">
                The Subscriber must inform the Service Provider at least one (1)
                working day (before 4pm) prior to the appointment date for any
                rescheduling or cancellation of the installation. However, the
                Service Provider may not be able to guarantee the preferred date
                of the Subscriber. The Service Provider reserves the right to
                charge you a certain fee at the prevailing rate for any late
                rescheduling or cancellation request.
              </li>
              <li className="leading-loose">
                The Subscriber consents to the Service Provider and/or our
                agents gaining access to the installation address provided by
                the Subscriber upon registration. The Service Provider will not
                be held responsible for any installation issues arising from
                errors in details of the installation address provided by you.
              </li>
              <li className="leading-loose">
                For installation of the fixed broadband service, Subscribers
                must agree to the drilling area (if required) before beginning
                installation.
              </li>
              <li className="leading-loose">
                The Subscriber must be present during installation, or in the
                event the Subscriber cannot be present, must designate a person
                aged 18 or above to be present on your behalf for installation
                of the Service, failing which the Service provider will not
                proceed with the installation.
              </li>
            </ol>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-7">
          <AccordionTrigger>7. Equipment</AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li className="leading-loose">
                If the Subscriber is relocating, the Subscriber must provide the
                Service Provider with prior notice of their relocation.
                Relocation will be subject to the Service coverage area.
              </li>
              <li className="leading-loose">
                The Subscriber may be subject to the applicable installation
                and/or relocation fees.
              </li>
              <li className="leading-loose">
                The Subscriber will be required to bring over the equipment
                provided by the Service Provider (which includes accessories for
                equipment to connect to the fixed broadband or to the fibre wall
                socket) from the current installation address to the new
                relocation address.
              </li>
              <li className="leading-loose">
                The Subscriber is responsible, at all times, for the safety of
                the Service Provider’s Equipment at the installation address
                provided. Upon termination of the Service, the Service
                Provider’s Equipment shall be returned in good working
                condition, failing which the Subscriber may be charged a
                penalty.
              </li>
              <li className="leading-loose">
                The Equipment provided to you by the Service Provider remains
                the Service Provider’s property.
              </li>
              <li className="leading-loose">
                The Equipment provided by the Service Provider on installation
                has a warranty that is reflective of the Subscriber’s contract
                with the Service Provider. The Subscriber may purchase their own
                equipment for using the Service, but the Service Provider shall
                not in any way warrant the quality of the Service from the
                Subscriber’s equipment.
              </li>
              <li className="leading-loose">
                Warranty for the Equipment provide does not cover:
              </li>
              <ol className="list-[lower-alpha] space-y-1 pl-10">
                <li className="leading-loose">
                  damage, lost, stolen or defects caused by any act, omission,
                  misuse, negligence including usage of the Equipment contrary
                  to instructions provided by the Service Provider or the
                  manufacturer;
                </li>
                <li className="leading-loose">
                  where the serial number/IMEI has been removed or defaced;
                </li>
                <li className="leading-loose">
                  products that have been subject to unauthorised removal or
                  deactivation of the Service Provider-lock function.
                </li>
              </ol>
              <li className="leading-loose">
                The Service Provider may suggest and upsell devices to the
                Subscriber which may improve the Service connectivity at the
                installation address. The Subscriber may be charged either as a
                one-off fee OR as a monthly value added plan.
              </li>
              <li className="leading-loose">
                The Subscriber will be tied to a commitment period for devices
                with a monthly instalment plan where the commitment period will
                be monthly, 12 or 24 months depending on the Plan and Service
                subscribed to.
              </li>
              <li className="leading-loose">
                The Subscriber may not, during the commitment period:
              </li>
              <ol className="list-[lower-alpha] space-y-1 pl-10">
                <li className="leading-loose">terminate the Service;</li>
                <li className="leading-loose">
                  terminate or suspend the Service account or port out to
                  another internet service provider;
                </li>
                <li className="leading-loose">
                  have your Service account terminated for non-payment of
                  monthly bills;
                </li>
                <li className="leading-loose">
                  change or transfer ownership of the Subscriber’s account and /
                  or the Service.
                </li>
              </ol>
              <li className="leading-loose">
                If the Subscriber suspends Service during the commitment period,
                the device’s monthly instalment fee will continue to be charged
                to the Subscriber.
              </li>
            </ol>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-8">
          <AccordionTrigger>8. Specific Obligations</AccordionTrigger>
          <AccordionContent>
            <ol className="list-decimal space-y-1 pl-12">
              <li>The Subscriber agrees that:</li>
              <ol className="list-[lower-alpha] space-y-1 pl-10">
                <li className="leading-loose">
                  They have read, understood and accepted these Specific Terms
                  and these Specific Obligations which regulates their use of
                  the Services above including the General Terms and Conditions;
                </li>
                <li className="leading-loose">
                  Data Add-on purchases will be billed to the monthly bill for
                  the respective broadband subscribers;
                </li>
                <li className="leading-loose">
                  Data Add-On packages can be purchased via the Service
                  Provider’s Platform;
                </li>
                <li className="leading-loose">
                  Data Add-On purchases cannot be cancelled and are not
                  refundable;
                </li>
                <li className="leading-loose">
                  For any Contract Plans depicted above or on the Platform, the
                  Subscriber shall enter into the mandatory contractual term
                  that shall commence from the date of subscribing to the Plan
                  and shall pay the applicable fees or charges of the subscribed
                  Plan;
                </li>
                <li className="leading-loose">
                  The standard warranty terms on any device Bundled with their
                  Contract may vary according to its make and model;
                </li>
                <li className="leading-loose">
                  For any Plan depicted on the Platform, the Subscriber shall be
                  obliged to pay the applicable deposit stipulated before its
                  commencement of using the services;
                </li>
                <li className="leading-loose">
                  Fair Use Policy applies for mobile wireless or fixed broadband
                  Services;
                </li>
                <li className="leading-loose">
                  The Subscriber may notify the Service Provider prior to expiry
                  of their Contract Plan failing which the Contract Plan will be
                  automatically renewed upon expiry of their existing Contract
                  Plan;
                </li>
                <li className="leading-loose">
                  If they terminate any Contract plan prior to its completion,
                  the Subscriber may be subject to penalty fee that take into
                  consideration the remaining period of the Plan, the amount
                  equivalent to the device (if applicable) and/or any additional
                  fees at the discretion of the Service Provider;
                </li>
                <li className="leading-loose">
                  The terms and conditions for Mobi Specific Terms shall also be
                  applicable in addition to this Specific Terms & Conditions for
                  this Service;
                </li>
                <li className="leading-loose">
                  The Service Provider may terminate this Contract due to a
                  breach by the Subscriber to any of the terms above or to any
                  of its obligations and duties under the General Terms;
                </li>
                <li className="leading-loose">
                  Data roaming is available in the countries listed on the
                  Platform subject to the prevailing data roaming charges and
                  availability of the Service on the subscribed Plan;
                </li>
                <li className="leading-loose">
                  For any planned interruption Service(s), adequate notice will
                  be provided via the Platform or any other mode of
                  communication as deemed appropriate; and
                </li>
                <li className="leading-loose">
                  The Service Provider reserves the right at any time, without
                  being liable to the Subscriber, to interrupt, bar, suspend,
                  restrict the Service(s) for such time as the Service Provider
                  sees fit if the Subscriber uses such Service(s) for unlawful
                  activities or for fraudulent activities.
                </li>
              </ol>
              <li>The Service Provider agrees that:</li>
              <ol className="list-[lower-alpha] space-y-1 pl-10">
                <li className="leading-loose">
                  They shall not charge the Subscriber for use of any of its
                  support line, customer care or operator services unless
                  otherwise stated;
                </li>
                <li className="leading-loose">
                  They shall notify the mobile wireless and fixed broadband
                  users once they have used up to 80% and 100% of their local
                  data allowance. However, Subscribers can also access their
                  data usage via the Platform;
                </li>
                <li className="leading-loose">
                  The Subscriber may revise or upgrade their monthly
                  subscription plan via any of the Service Provider’s channels;
                </li>
                <li className="leading-loose">
                  Any deposit payment made by the Subscriber shall be refunded,
                  free of interest, to the Subscriber when their obligations
                  under the Contract or Plan has been fully performed and there
                  is no outstanding debt accrued;
                </li>
                <li className="leading-loose">
                  They shall provide the Subscriber with standard warranty terms
                  on any device Bundled with their Contract which may vary
                  according to its make and model.
                </li>
              </ol>
            </ol>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
